import styled from 'styled-components/macro';

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0 20px 0;
  justify-content: space-between;
`;

export default Container;
